/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// import Vue from 'vue';
// window.Vue = Vue;
// let axios = require('axios');
// window.axios = axios;
// let jQuery = require('jquery');
// window.$ = window.jQuery = jQuery;
// require('./size-chart');
__webpack_require__(/*! ./components/mobile-sidebar */ "./src/js/components/mobile-sidebar.js");

__webpack_require__(/*! ./components/home-page-slider */ "./src/js/components/home-page-slider.js");

/***/ }),

/***/ "./src/js/components/home-page-slider.js":
/*!***********************************************!*\
  !*** ./src/js/components/home-page-slider.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var mySwiper = new Swiper('.swiper-container', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: {
    delay: 3500
  },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination'
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});

/***/ }),

/***/ "./src/js/components/mobile-sidebar.js":
/*!*********************************************!*\
  !*** ./src/js/components/mobile-sidebar.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var tMMenuButton = document.querySelector('.tMMenuTrigger');
var tMSiderbarCloseButton = document.querySelector('.tms__sidebar-close');
var tMSiderbarWrapper = document.querySelector('.tms');
var tMSiderbar = document.querySelector('.tms__sidebar');
  var ColSlider=document.querySelector('.collection-slider');
tMMenuButton.addEventListener('click', function () {
  $('.collection-slider').removeClass('slick-prev');
 
  tMSiderbarWrapper.classList.add('is-visible');
  tMSiderbar.classList.add('is-visible');


});
tMSiderbar.addEventListener('click', function (evnt) {
  evnt.stopPropagation();
  
 
}); ////////////////////////////////////////////////////////////////// 
// Closing the Menu

console.log(tMSiderbarCloseButton);
tMSiderbarWrapper.addEventListener('click', function () {
  tMSiderbar.classList.remove('is-visible');
  setTimeout(function () {
    tMSiderbarWrapper.classList.remove('is-visible');
  }, 200);
});
tMSiderbarCloseButton.addEventListener('click', function () {
  tMSiderbar.classList.remove('is-visible');
  setTimeout(function () {
    tMSiderbarWrapper.classList.remove('is-visible');
  }, 200);
}); ///////////////////////////////////////////////////////////// 
// Mobile Accordions

var accordions = document.querySelectorAll('.tms__menu__accordion');
accordions.forEach(function (accordion) {
  accordion.addEventListener('click', function (event) {
    var content = event.target.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      console.log('Accordion is open.');
      content.style.maxHeight = null;
    } else {
      console.log('Accordion is closed.');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!*************************************************!*\
  !*** multi ./src/js/app.js ./src/scss/app.scss ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! D:\This is it\001\src\js\app.js */"./src/js/app.js");
module.exports = __webpack_require__(/*! D:\This is it\001\src\scss\app.scss */"./src/scss/app.scss");


/***/ })

/******/ });